import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import DeliverExperiencesImage from './DeliverExperiencesImage'

const copy = {
  title: `Deliver relevant experiences to each customer`,
  elements: [
    {
      title: `All of your customer data, all in one place`,
      description: `Break down data silos to build a deep and unified understanding of every customer across all online and offline sources.`,
      ctaUrl: `/product/unify/`,
      ctaText: `See unified customer profiles in action`,
    },
    {
      title: `Power dynamic customer journeys in real-time`,
      description: `Customer needs aren't static, so your customer journeys shouldn't be either. Segment's real-time customer profiles, dynamic audiences, and journey orchestration ensure your multi-channel experiences can respond when new customer signals emerge.`,
      ctaUrl: `/product/twilio-engage/journeys/`,
      ctaText: `Explore journey orchestration with Segment`,
    },
  ],
}

const DeliverExperiences = () => {
  return (
    <Wrapper>
      <StyledSectionBaseTitle variant="noCopy">
        <Section.Contents>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h2">{copy.title}</CopyText.Heading>
          </CopyTextBase>
        </Section.Contents>
      </StyledSectionBaseTitle>
      <StyledSectionBaseContent variant="2Col">
        <Section.Contents>
          <DeliverExperiencesImage />
        </Section.Contents>
        <Section.Copy alignSelf="center">
          <ColumnTrack>
            {copy.elements.map(({ title, description, ctaText, ctaUrl }, key) => (
              <CopyTextBase key={key}>
                <CopyText.Heading tag="h3" variant="pLargeBold">
                  {title}
                </CopyText.Heading>
                <CopyText.Description tag="p" variant="pMedium">
                  {description}
                </CopyText.Description>
                <CopyText.Link href={ctaUrl}>{ctaText}</CopyText.Link>
              </CopyTextBase>
            ))}
          </ColumnTrack>
        </Section.Copy>
      </StyledSectionBaseContent>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.mint[10]};
`

const StyledSectionBaseTitle = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 80px;
    padding-bottom: 0;
  }
`

const StyledSectionBaseContent = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 60px;
    padding-bottom: 50px;
  }
`

export default DeliverExperiences
